// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2MmZL","centered":"Spinner_centered__18Oc0","spinner__icon":"Spinner_spinner__icon__AfdZN","spinner__svg":"Spinner_spinner__svg___IK3j"};